<template>
  <el-popover width="fit-content" :hide-after="0" :trigger="trigger">
    <div class="container">
      <div class="row">
        <span class="label">姓名:</span>
        <span>{{ userMap[userId]?.name }}</span>
      </div>

      <div class="row">
        <span class="label">职位:</span>
        <div class="arch-list-wrapper">
          <el-tag v-for="(archId, index) in toArray(userMap[userId]?.archIds)" :key="index" type="primary">
            <template v-for="(archNode, subIndex) in trimHead(archMap[archId])" :key="subIndex">
              <span v-if="subIndex !== 0" class="split">/</span>
              <span :class="{ 'head-title': archNode.head === userId }">{{ archNode.title }}</span>
            </template>
          </el-tag>
        </div>
      </div>

      <div class="row">
        <span class="label">电话:</span>
        <span>{{ userMap[userId]?.telephone }}</span>
      </div>
    </div>

    <template #reference>
      <el-link type="primary" :underline="false">{{ userMap[userId]?.name }}</el-link>
    </template>
  </el-popover>
</template>

<script setup>
import { isString } from '@safety/shared-utils'

defineProps({
  /**
   * 用户映射表,key为用户id,value为用户对象,包含name,telephone,archIds,archIds可以是数组或者逗号分割的字符串
   */
  userMap: Object,
  /**
   * 角色映射表,key为角色id,value为角色节点数组,包含顶级节点(即公司级)
   */
  archMap: Object,
  userId: Number,
  trigger: {
    type: String,
    default: 'hover'
  }
})

/**
 * 职位名去掉公司名，除非只有公司名
 */
function trimHead(role) {
  if (role) {
    return role.length > 1 ? role.slice(1) : role
  } else {
    return []
  }
}

/**
 * 字符串转数组
 * @param {string | Array} strs
 * @returns {Array} 返回数组,非空
 */
function toArray(strs) {
  if (isString(strs)) {
    return strs.split(',')
  } else if (Array.isArray(strs)) {
    return strs
  } else {
    return []
  }
}
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.row {
  display: flex;
}
.label {
  margin-right: 10px;
  width: 50px;
  font-weight: bold;
}
.arch-list-wrapper {
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-start;
}
.head-title {
  color: red;
}
.split {
  margin: 0 3px;
}
</style>
